import { useCallback as e, useEffect as t, useRef as n, useState as r } from "react";
//#region src/components/FullscreenGallery/hooks/useGalleryNavigation.ts
var i = (i, a, o) => {
	let [s, c] = r(a), l = n(o);
	t(() => {
		o && !l.current && c(a), l.current = o;
	}, [o, a]);
	let u = e((e) => {
		c(Math.max(0, Math.min(e, i - 1)));
	}, [i]), d = e(() => {
		c((e) => Math.min(e + 1, i - 1));
	}, [i]), f = e(() => {
		c((e) => Math.max(e - 1, 0));
	}, []);
	return {
		currentIndex: s,
		totalImages: i,
		canPrev: s > 0,
		canNext: s < i - 1,
		goTo: u,
		goNext: d,
		goPrev: f
	};
};
//#endregion
export { i as useGalleryNavigation };
